<ngx-skeleton-loader
  *ngIf="isLoading"
  [count]="count"
  [appearance]="appearance"
  [theme]="{
    'border-radius': '5px',
    height: '45.89px',
    'margin-bottom': '0px',
  }"
></ngx-skeleton-loader>
<ng-content *ngIf="!isLoading"></ng-content>
